import React, { useEffect, useState } from "react";
import HeaderImageSection from "../shared/headerImageSection";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "./search.scss";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import axios from "axios";
import {
  ageValues,
  API_URL,
  mangalValues,
  occupationTypeValues,
} from "../../variables";
import { ToastContainer, toast } from "react-toastify";
import dummyProfileImg from "../../assets/committeeProfileImg.png";
import ProfileDetails from "../profiles/profileDetails";
import { convertBirthTime } from "../../sharedFunctions";
import CancelIcon from "@mui/icons-material/Cancel";
import Loader from "../shared/loader/loader";

const Search = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [id, setId] = useState();
  const [profile, setProfile] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [searchValues, setSearchValues] = useState({
    gender: "male",
    diet: "both",
    maritial_status: "unmarried",
    age_from: "",
    age_to: "",
    // height_from: "",
    // height_to: "",
    occupation_type: "",
    mother_tongue: "",
    mangal: "",
    education_area: "",
    occupation_place: "",
    native_place: "",
  });

  useEffect(() => {
    if (pageNo > 0) searchByValues();
  }, [pageNo]);

  const searchById = async () => {
    let obj = {
      member_id: id?.toUpperCase(),
    };
    let res = await axios.post(
      API_URL + "searchmember?data=" + JSON.stringify(obj)
    );
    if (res?.data.body.length > 0) {
      setSearchResults(res?.data.body);
      toast.success(
        res?.data.body.length +
          " search result(s) found, please scroll bottom of the screen to view the profiles.",
        {
          position: "top-center",
          autoClose: 8000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    } else {
      setSearchResults(res?.data.body);
      toast.warning(res?.data.message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const searchByValues = async () => {
    let obj = Object.fromEntries(
      Object.entries(searchValues).filter(([_, value]) => {
        return value != "";
      })
    );
    console.log('obj.............',obj)
    setShowLoader(true);
    let res = await axios.post(
      API_URL +
        "searchmemberpages?data=" +
        JSON.stringify(obj) +
        "&page=" +
        pageNo +
        "&limit=10"
    );
    if (res?.data.body.length > 0) {
      setShowLoader(false);
      setSearchResults(res?.data.body);
      toast.success("Profile(s) found", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setShowLoader(false);
      //setSearchResults(res?.data.body);
      toast.info(res?.data.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Loader show={showLoader} />
      <ToastContainer />
      <Header />
      <HeaderImageSection />
      <section className="p-4 container">
        <div className="row d-flex align-items-center justify-content-center">
          <div className="col-sm-12 col-md-3">
            <label>Single Registration ID Search</label>
          </div>
          <div className="col-sm-12 col-md-6">
            <Box className="">
              <TextField
                className="w-100"
                id="outlined-basic"
                label=""
                variant="outlined"
                value={id?.toUpperCase()}
                onChange={(event) => {
                  setId(event.target.value?.toUpperCase());
                }}
              />
            </Box>
          </div>
          <div className="col-sm-12 btnWrapper col-md-3 pr-3">
            <Button
              size="large"
              variant="contained"
              className="buttonClass"
              onClick={() => {
                searchById();
              }}
            >
              Search
            </Button>
          </div>
        </div>
        <div className="mt-5 mb-3 border-top text-center border-dark position-relative">
          <span className="orText">OR</span>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Gender :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="gender"
                        row
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            gender: event.target.value,
                          }));
                        }}
                        value={searchValues.gender}
                      >
                        <FormControlLabel
                          value="male"
                          control={<Radio />}
                          label="Male"
                        />
                        <FormControlLabel
                          value="female"
                          control={<Radio />}
                          label="Female"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Diet :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="diet"
                        row
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            diet: event.target.value,
                          }));
                        }}
                        value={searchValues.diet}
                      >
                        <FormControlLabel
                          value="veg"
                          control={<Radio />}
                          label="Veg"
                        />
                        <FormControlLabel
                          value="non veg"
                          control={<Radio />}
                          label="Non Veg"
                        />
                        <FormControlLabel
                          value="both"
                          control={<Radio />}
                          label="Both"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Maritial Status :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="status"
                        row
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            maritial_status: event.target.value,
                          }));
                        }}
                        value={searchValues.maritial_status}
                      >
                        <FormControlLabel
                          value="unmarried"
                          control={<Radio />}
                          label="Unmarried"
                        />
                        <FormControlLabel
                          value="divorcee"
                          control={<Radio />}
                          label="Divorcee"
                        />
                        <FormControlLabel
                          value="widowed"
                          control={<Radio />}
                          label="Widowed"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Age :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <InputLabel id="demo-simple-select-autowidth-label">
                        From
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        autoWidth
                        label="Age"
                        value={searchValues.age_from}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            age_from: event.target.value,
                          }));
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {ageValues.map((item, index) => {
                          return (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <InputLabel id="demo-simple-select-autowidth-label">
                        To
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        autoWidth
                        label="Age"
                        value={searchValues.age_to}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            age_to: event.target.value,
                          }));
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {ageValues.map((item, index) => {
                          return (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Height :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <InputLabel id="demo-simple-select-autowidth-label">
                        From
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value=""
                        autoWidth
                        label="Age"
                      >
                        <MenuItem value={22}>22</MenuItem>
                        <MenuItem value={23}>23</MenuItem>
                        <MenuItem value={24}>24</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <InputLabel id="demo-simple-select-autowidth-label">
                        To
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value=""
                        autoWidth
                        label="Age"
                      >
                        <MenuItem value={22}>22</MenuItem>
                        <MenuItem value={23}>23</MenuItem>
                        <MenuItem value={24}>24</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Occupation :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        autoWidth
                        value={searchValues.occupation_type}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            occupation_type: event.target.value,
                          }));
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {occupationTypeValues.map((item, index) => {
                          return (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Mother Toungue :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        autoWidth
                        value={searchValues.mother_tongue}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            mother_tongue: event.target.value,
                          }));
                        }}
                      >
                        <span className="pl-3 font-bold">
                          Official Languages
                        </span>
                        <MenuItem value={"Hindi"}>Hindi</MenuItem>
                        <MenuItem value={"English"}>English</MenuItem>
                        <MenuItem value={"Other"}>Other</MenuItem>
                        <span className="pl-3 font-bold">Major Languages</span>
                        <MenuItem value={"Bengali"}>Bengali</MenuItem>
                        <MenuItem value={"Telugu"}>Telugu</MenuItem>
                        <MenuItem value={"Marathi"}>Marathi</MenuItem>
                        <MenuItem value={"Tamil"}>Tamil</MenuItem>
                        <MenuItem value={"Gujarati"}>Gujarati</MenuItem>
                        <MenuItem value={"Malayalam"}>Malayalam</MenuItem>
                        <MenuItem value={"Kannada"}>Kannada</MenuItem>
                        <MenuItem value={"Odia"}>Odia</MenuItem>
                        <MenuItem value={"Punjabi"}>Punjabi</MenuItem>
                        <MenuItem value={"Assamese"}>Assamese</MenuItem>
                        <MenuItem value={"Maithili"}>Maithili</MenuItem>
                        <MenuItem value={"Santhali"}>Santhali</MenuItem>
                        <MenuItem value={"Kashmiri"}>Kashmiri</MenuItem>
                        <MenuItem value={"Nepali"}>Nepali</MenuItem>
                        <MenuItem value={"Konkani"}>Konkani</MenuItem>
                        <MenuItem value={"Manipuri"}>Manipuri</MenuItem>
                        <MenuItem value={"Dogri"}>Dogri</MenuItem>
                        <span className="pl-3 font-bold">
                          Regional Languages and Dialects
                        </span>
                        <MenuItem value={"Bodo"}>Bodo</MenuItem>
                        <MenuItem value={"Khasi"}>Khasi</MenuItem>
                        <MenuItem value={"Sindhi"}>Sindhi</MenuItem>
                        <MenuItem value={"Urdu"}>Urdu</MenuItem>
                        <MenuItem value={"Rajasthani"}>Rajasthani</MenuItem>
                        <MenuItem value={"Magahi"}>Magahi</MenuItem>
                        <MenuItem value={"Bhojpuri"}>Bhojpuri</MenuItem>
                        <MenuItem value={"Chhattisgarhi"}>
                          Chhattisgarhi
                        </MenuItem>
                        <MenuItem value={"Haryanvi"}>Haryanvi</MenuItem>
                        <MenuItem value={"Awadhi"}>Awadhi</MenuItem>
                        <MenuItem value={"Garhwali"}>Garhwali</MenuItem>
                        <MenuItem value={"Himachali"}>Himachali</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Mangal :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <Select
                        className="text-capitalize"
                        value={searchValues.mangal}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            mangal: event.target.value,
                          }));
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {mangalValues.map((item, index) => {
                          return (
                            <MenuItem
                              value={item}
                              key={index}
                              className="text-capitalize"
                            >
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Education :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <Select
                        className="text-capitalize"
                        value={searchValues.education_area}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            education_area: event.target.value,
                          }));
                        }}
                      >
                        <MenuItem className="text-capitalize" value="">
                          Select
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="12th">
                          10th
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="12th">
                          12th
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="diploma">
                          Diploma
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="graduate">
                          Graduate
                        </MenuItem>
                        <MenuItem
                          className="text-capitalize"
                          value="post graduate"
                        >
                          Post - Graduate
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="doctor">
                          Doctor
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="engineer">
                          Engineer / PG Engg
                        </MenuItem>
                        <MenuItem className="text-capitalize" value="other">
                          Other
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Ocupation Place :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Enter the place"
                        value={searchValues.occupation_place}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            occupation_place: event.target.value,
                          }));
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 d-flex align-items-center justify-content-end textDarkRed">
                    <FormLabel
                      className="font-bold"
                      id="demo-radio-buttons-group-label"
                    >
                      Native Place :
                    </FormLabel>
                  </div>
                  <div className="col-sm-8">
                    <FormControl sx={{ m: 1, minWidth: 260 }} size="small">
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Enter place"
                        value={searchValues.native_place}
                        onChange={(event) => {
                          setSearchValues((prev) => ({
                            ...prev,
                            native_place: event.target.value,
                          }));
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 text-center">
                <Button
                  size="large"
                  variant="contained"
                  className="buttonClass"
                  onClick={() => {
                    searchByValues();
                    setPageNo(1);
                  }}
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
          <div className="col-sm-4 helpVideos">
            <label className="d-flex justify-content-center pt-4">
              Help Videos
            </label>
            <div className="videoContainerImg mb-3 d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <div className="videoContainerImg mb-3 d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
          </div>
        </div>
      </section>
      <div className="row searchResultsSection">
        {searchResults?.map((item, index) => {
          return (
            <div key={index} className="col-md-6 p-2">
              <div className="profileWrapper d-flex justify-content-start">
                <div className="w-25 d-flex justify-content-center align-items-center profileDataView">
                  <img
                    alt=""
                    className="profileImg"
                    src={
                      item.images.length > 0
                        ? `data:image/jpeg;base64,${item.images[0]}`
                        : dummyProfileImg
                    }
                  />
                </div>
                <div className="w-75 profileData">
                  <div>
                    <div className="">
                      <div className="id p-2 d-flex justify-content-between align-items-center">
                        <label className="textDarkRed mb-0 ">
                          <span>
                            Register No / नोंदणी क्रv-
                            <span className="font-bold">
                              {item.member_id} ({item.last_name.toUpperCase()})
                            </span>
                          </span>
                        </label>
                        <label
                          className="textDarkRed pt-3 hyperLink mr-3"
                          onClick={() => {
                            setProfile(item);
                            setShowDetails(true);
                            //navigate("/profilesDetails/" + item.member_id);
                          }}
                        >
                          View Profile
                        </label>
                      </div>
                    </div>
                    <div className="details p-1">
                      <div className="row pt-3 p-2">
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Last Name / आडनाव
                          </label>
                          <label className="textDarkRed font-bold text-capitalize">
                            {item.last_name}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Date of birth / जन्मतारीख
                          </label>
                          <label className="textDarkRed font-bold">
                            {item.dob}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">Rashi / राशी</label>
                          <label className="textDarkRed font-bold text-capitalize">
                            {item.rashi.toUpperCase() === "NA"
                              ? "-"
                              : item.rashi}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Birth Time / जन्मस्वेळ
                          </label>
                          <label className="textDarkRed font-bold">
                            {convertBirthTime(item.birth_time)}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Height / उंची (ft: inch)
                          </label>
                          <label className="textDarkRed font-bold">
                            {item.heightFt ? item.heightFt + " feet" : ""}{" "}
                            {item.heightInch ? item.heightInch + " inches" : ""}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Education / शिक्षण
                          </label>
                          <label className="textDarkRed font-bold">
                            {item.education.toUpperCase()}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            City /नोकरी शहर
                          </label>
                          <label className="textDarkRed font-bold text-capitalize">
                            {item.city}
                          </label>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="labelName mb-0">
                            Income / उत्पन्न
                          </label>
                          <label className="textDarkRed font-bold">
                            Rs. {item.income_amt} {item.income_type}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {searchResults?.length > 0 && (
          <div className="d-flex align-items-center justify-content-center p-3 w-100">
            <ArrowCircleLeftIcon
              className="inline-block mr-4 textDarkRed font22px arrowForPageChange"
              onClick={() => {
                if (pageNo > 1) setPageNo(pageNo - 1);
              }}
            />
            <ArrowCircleRightIcon
              className="inline-block  textDarkRed font22px arrowForPageChange"
              onClick={() => {
                setPageNo(pageNo + 1);
              }}
            />
          </div>
        )}
      </div>
      <Dialog
        open={showDetails}
        onClose={() => {
          setShowDetails(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="profileDetailsPopup"
      >
        <DialogActions>
          {/* <Button onClick={()=>{setShowDetails(false)}}>Close</Button> */}
          <CancelIcon
            onClick={() => {
              setShowDetails(false);
            }}
            className="cursorPointer"
          />
        </DialogActions>
        <DialogContent className="pt-0">
          <ProfileDetails
            profileData={profile}
            showAllDetailsByDefault={false}
            showGetContactBtn={
              localStorage.getItem("userLoggedIn") === null
                ? "false"
                : localStorage.getItem("member_status") === "active"
                ? true
                : false
            }
          />
        </DialogContent>
      </Dialog>
      <FooterComponent />
    </>
  );
};

export default Search;
